// The splash: for the first 2.6 seconds after the application loads, the
// legacy start page showed the product and "powered by gosh! Audio" in a
// full-screen dialog, and the bar and the content faded in after it. The bar
// and the start page are different components, so the state lives here.
//
// It runs once per page load, and only when the window has the focus — a tab
// opened in the background skipped it in the legacy application too.

import { useSyncExternalStore } from "react";

export const INTRO_MS = 2600;

let state: "pending" | "running" | "done" = "pending";
const listeners = new Set<() => void>();
const emit = () => listeners.forEach((l) => l());

/** startIntro begins the splash if it has not run yet, and says whether it did. */
export function startIntro(): boolean {
  if (state !== "pending") return false;
  if (typeof document !== "undefined" && !document.hasFocus()) {
    state = "done";
    emit();
    return false;
  }
  state = "running";
  emit();
  window.setTimeout(() => {
    state = "done";
    emit();
  }, INTRO_MS);
  return true;
}

/** skipIntro is for the routes that never showed it: the wizard and the settings. */
export function skipIntro() {
  if (state === "pending") {
    state = "done";
    emit();
  }
}

function subscribe(l: () => void) {
  listeners.add(l);
  return () => listeners.delete(l);
}

export function useIntro(): "pending" | "running" | "done" {
  return useSyncExternalStore(subscribe, () => state, () => state);
}
